module.exports = __webpack_public_path__ + "img/029-pantone.fbd26d57.svg";